import { usePatchApiAdminCompanyEntity, } from '../../generated/sitComponents';
export function usePatchAdminCompanyEntity(options) {
    return usePatchApiAdminCompanyEntity({
        ...options,
        onSettled: (data, error, variables, onMutateResult, context) => {
            context.client.invalidateQueries({ queryKey: ['admin', 'companies'] });
            options?.onSettled?.(data, error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-patch-admin-company-entity.js.map